import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import Moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import './AuthValidate.css';
import { setDigitalData } from '../../Utilities/Utils.js';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"white" ,
            secondary: "white"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});

const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
    },
    disabled: {},
    focused: {},
    error: {}
}

class DGRAuthValidate extends Component {

    componentDidMount() {
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.errors = null;
        setDigitalData( 'auth validate', this.props.DGRStore.club_number );
    }

    handleChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.value );
    }

    handleSubmitCheckinBirthday = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Login',
            action: 'Validate Membership'
        });

        var buttonText = this.refs.submitButton.innerHTML;
        this.refs.submitButton.innerHTML = 'Validating...'
        this.refs.submitButton.setAttribute( 'disabled', 'disabled' );

        this.props.DGRStore.authValidate().then( response => {
            if ( response ) {
                this.props.history.push( '/auth/verify' );
            } else {
                this.refs.submitButton.removeAttribute( 'disabled' );
                this.refs.submitButton.innerHTML = buttonText;
            }
        })
    }

    errorText() {

        if ( !this.props.DGRStore.errors ) {
            return null;
        }
 
        return (
            <div className="errorMessage">
                { this.props.DGRStore.errors }
            </div>
        );
    }

    render(){
        const { classes } = this.props;
        const { year, day, month, memberIdentifier } = this.props.DGRStore.values;

        //TODO
        //date stuff that is shared with enterpass.js - refactor to single component, or least utils
        const fillRange = (start, end) => {
            return Array(end - start + 1).fill().map((item, index) => start + index);
        };

        const daysArray = fillRange(1, 31);
        const days = daysArray.map( (day, i ) => {
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    key={i}
                    value={day}
                 >{day}</MenuItem>
            );
        })
        const monthsArray = fillRange(0, 11);
        const months = monthsArray.map( (month, i) => {
            var momentInstance = Moment
            const monthName = momentInstance.months(i)
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    key={i}
                    value={i}
                 >{monthName}</MenuItem>
            )
        })
        var yearsArray = fillRange( ( new Date().getFullYear() - 100 ), new Date().getFullYear() );
        yearsArray = yearsArray.reverse()
        const years = yearsArray.map( (year, i ) => {
            return (
                <MenuItem
                    classes={{
                        root: classes.menuItem
                      }}
                    className="year"
                    key={i} value={year}
                    >{year}
                </MenuItem>
            );
        })

        return(
            <Fade>
            <div className="authLogin">
                <MuiThemeProvider theme={theme}>

                <div className="dgrTitleText">
                    <h2>Create New Account</h2>
                </div>

                <div className="dgrTitleSubText">
                    <div className="subText">
                        Setup online access to your membership account in three easy steps.
                    </div>
                </div>

                <div className="loginItems">  
                    <ValidatorForm
                        className="loginForm"
                        ref="form"
                        autoComplete="off"
                        instantValidate={ false }
                        onSubmit={ this.handleSubmitCheckinBirthday }
                        onError={ errors => console.log(errors) }
                    >

                        <h3>Step 1: Validate Membership</h3>
                        <div className="row">
                            <TextValidator
                                autoComplete="off"
                                label="Member Number or Check-In Code"
                                name="memberIdentifier"
                                id="checkinCodeField"
                                value={ memberIdentifier }
                                key="0"
                                onChange={ this.handleChange }
                                placeholder="eg: 5551234567"
                                className="inputField"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                margin="normal"
                            />
                        </div>
                        <div className="row birthdayRow">
                            <label className="birthdayLabel">Birthday:</label>
                            <SelectValidator
                                name="month"
                                className="birthdaySel"
                                value={month}
                                onChange={this.handleChange}
                                InputProps={{
                                    classes: {
                                        underline: classes.underline
                                    },
                                    name: 'month',
                                    id: 'month',
                                }}
                            >
                                {months}
                            </SelectValidator>
                            <SelectValidator
                                name="day"
                                className="birthdaySel"
                                value={day}
                                onChange={this.handleChange}
                                InputProps={{
                                    classes: {
                                        underline: classes.underline
                                    },
                                    name: 'day',
                                    id: 'day',
                                }}
                            >
                                {days}
                            </SelectValidator>
                            <SelectValidator
                                name="year"
                                className="birthdaySel"
                                value={year}
                                onChange={this.handleChange}
                                InputProps={{
                                    classes: {
                                        underline: classes.underline
                                    },
                                    name: 'year',
                                    id: 'year',
                                }}
                            >
                                {years}
                            </SelectValidator>
                        </div>

                        { this.errorText() }

                        <div className="continueBtn">
                            <button ref="submitButton" className="bigButton" type="submit">Continue</button>
                        </div>

                        <div className="subLink">
                            <Link to="/auth/login"> 
                                &laquo; Cancel and return to login form
                            </Link>
                        </div>

                    </ValidatorForm>

                </div>
                </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGRAuthValidate = inject('DGRBackgroundStore','DGRStore')( observer( DGRAuthValidate ) )

export default withStyles( styles )( DGRAuthValidate );



// WEBPACK FOOTER //
// ./src/components/DGR/AuthValidate/AuthValidate.js